export default __webpack_public_path__ + "static/media/tick.796430e4.svg";